import dynamic from 'next/dynamic'
import { TradeAreaIcon } from 'src/components/insights/icons/trade-area'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/tta-overview.png'

const Overview = dynamic(() => import('src/components/insights/true-trade-area/overview'), { ssr: false })

export const OverviewWidget: InsightBuilderWidget = {
  id: 'true-trade-area-overview',
  name: 'True Trade Area: Overview',
  type: 'True Trade Area',
  icon: TradeAreaIcon,
  component: Overview,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
